import React, {useState,useEffect} from 'react';
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {Inc,Item,Owner,Override,OverrideEvent,Dataset,DataErrorset,DataErrorset2,ItemNameLengthMin,ItemNameLengthMax,ItemPriceMin,ItemPriceMax,ItemPriceMaxHigh,ItemGuideLengthMax,ItemGuideNameLengthMax,ItemPromoTextLengthMax,ItemThankyouLengthMax,ItemTagsMax,EventTagsMax,EventTagNameLengthMin,EventTagNameLengthMax,WordsLengthMax} from './Inc';
import Ajax from './Ajax';
import InputString from './InputString';
import InputNumber from './InputNumber';
import RowData from './RowData';
import DropImage from './DropImage';
import DropImageLight from './DropImageLight';
import ColInput from './ColInput';
import Loading from './Loading';
import Yesno from './Yesno';
import Problems from './Problems';
import useStyles from './Styles';
import Toast from './Toast';
import {Tools} from './Tools';

interface OverrideInputProps {
	owner:Owner,
	managerId:number,
	itemId?:number,
	event?:OverrideEvent,
	itemOverrideId?:number,
	isOpen:boolean,
	close(updated:boolean):void,
}

interface OverrideInputParams {
	photo_ids:number[],
	guides:DataErrorset2[],
}

const OverrideInput = (props:OverrideInputProps)=> {
	Ajax.setEditorId(props.owner.owner_id);
	const classes = useStyles();
	
	const defStates = {
		override: Inc.defaultOverride(),
		item: Inc.defaultOverride(),
		pages: [] as Dataset[],
		yesno: '',
		deleteIndex: -1,
		problems: [] as string[],
		notFound: false,
		errors: [] as string[],
		isLoading: true,
		isProcessing: false,
		item_imgs: {} as { [key: string]: string; },
		event: {} as OverrideEvent,
		//targets: [] as string[],
	};
	const [states,setStates] = useState({...defStates});
	const [toast,setToast] = useState("");

	const load = (pages:Dataset[])=>{
		//console.log("load",props.event);
		let params = {} as {[key:string]:any;};
		if( props.itemOverrideId ){
			params["item_override_id"] = props.itemOverrideId;
		} else {
			params["item_id"] = props.itemId;
			params["period"] = props.event?.period;
		}
		Ajax.send("override/get",params,(res:any)=>{
			//console.log("load",res);
			if( res.ok ){
				let errors = [] as string[];
				if( !res.item.item_name || res.item.item_name==='' || res.item.item_name.length<ItemNameLengthMin ){
					errors.push('item_name');
				}
				setStates({...defStates,
					override:Inc.convOverride(res.override),
					item:Inc.convOverride(res.item),
					pages:pages,
					item_imgs:{},
					event: props.event ? props.event : res.event as OverrideEvent,
					//targets:res.override.targets,
					errors:errors,
					isLoading:false});
			} else {
				setStates({...states,notFound:true,isLoading:false});
			}
		});
	}

	const onChangeString = (name:keyof Override) => (value: string,hasError: boolean) => {
		validateItem({...states.override,[name]:value},name,hasError);
	};

	const onChangeGuide = (index:number,side:number) => (value: string,hasError: boolean) => {
		let guides = [...states.override.guides];
		if( side===0 ){
			guides[index].id = value;
			guides[index].id_error = hasError;
		} else if( side===1 ){
			guides[index].label = value;
			guides[index].label_error = hasError;
		}

		hasError = false;
		for( let i=0; i<guides.length; i++ ){
			if( guides[i] ){
				if( guides[i].id_error || guides[i].label_error ){
					hasError = true;
				}
			}
		}

		const override = {...states.override,guides:guides};
		validateItem(override,'guides',hasError);
	};

	const onChangeNumber = (name:keyof Override) => (value: number,hasError: boolean) => {
		validateItem({...states.override,[name]:value},name,hasError);
	};

	const onChangeSelect = (name:keyof Override) => (event: SelectChangeEvent) => {
		if (!event) {
			return;
		}
		let value = event.target.value;
		setStates({
			...states,
			override:{...states.override,[name]:value},
		});
	}
	const validateItem = (override:Override,name:string,hasError:boolean)=>{
		let errors = [...states.errors];
		const index = errors.indexOf(name);
		if( index>=0 ){
			if(!hasError){
				errors.splice(index, 1);
			}
		} else {
			if(hasError){
				errors.push(name);
			}
		}
		setStates(prev => {
			return {
				...prev,
				override: override,
				errors: errors,
			};
		});
	}

	const checkItemName = async (value:string)=>{
		const res = await Ajax.sendAwait("item/name",
			{item_name:value,owner_id:props.owner.owner_id,item_id:states.override.item_id}
		);
		if( res.used ){
			return false;
		}
		return true;
	}

	const changeImage = (id:string,src:string)=>{
		if (id.substring(0, 5) === "photo") {
			setStates(prev => {
				const item_imgs = {...prev.item_imgs, [id]: src};
				let photo_ids = [...prev.override.photo_ids];
				photo_ids = Tools.treatPhotos([...photo_ids],id,src,item_imgs,8);
				return {
					...prev,
					override: {
						...prev.override,
						photo_ids: photo_ids,
					},
					item_imgs: item_imgs,
				};
			});
		} else {
			setStates(prev => {
				return {
					...prev,
					item_imgs: {...prev.item_imgs, [id]: src}
				};
			});
		}
	}
	const changeRadio = (name:keyof Override,value:string)=>{
		setStates(prev => ({
			...prev,
			override: { ...prev.override, [name]: value }
		}));
	}
	const addGuide = ()=>{
		const guides = [...states.override.guides];
		const guide = {
			id: '',
			label: '',
			id_error: false,
			label_error:false,
		} as DataErrorset2;
		guides.push(guide);
		setStates({...states,override:{...states.override,guides:guides}});
	}

	const confirmDelete = (event: React.MouseEvent)=>{
		const index = parseInt(event.currentTarget.getAttribute('data-num') as string);
		setStates({...states,yesno:'この段落を削除します。\nよろしいですか？',deleteIndex:index});
	}

	const deleteGuide = ()=>{
		if( states.deleteIndex<0 ){
			return;
		}
		let guides = [...states.override.guides];
		guides.splice(states.deleteIndex,1);
		setStates({...states,deleteIndex:-1,yesno:'',override:{...states.override,guides:guides}});
	}

	const close = ()=>{
		setStates(defStates);
		props.close(false);
	}

	const confirm = async ()=>{
		if( states.isProcessing ){
			return;
		}

		setStates({...states,isProcessing:true});

		// states.targetsにitem_nameが含まれていて、かつstates.override.item_nameに「架空の」が含まれていない場合はエラー
		const isKakuu = states.override.targets?.includes("item_name") && states.override.item_name.includes("架空の");
		let isUnique = true;
		if( !isKakuu ){
			isUnique = await checkItemName(states.override.item_name);
		}

		const validateErrors = [...states.errors];
		const requiredFields = ["item_name","promo_text","thankyou","unit"];
		//requiredFieldsのいずれかがstates.override.targetsに含まれていて、かつstates.override[フィールド]が空の場合はエラー
		for( let i=0; i<requiredFields.length; i++ ){
			const field = requiredFields[i] as keyof Override;
			let value = states.override[field] ? states.override[field] as String : '';
			if( states.override.targets?.includes(field) && value.trim()==='' ){
				validateErrors.push(field);
			}
		}

		// ギャラリーは無しにもできる
		// if( states.override.targets?.includes("img_id") ){
		// 	console.log("states.item_imgs",states.item_imgs);
		// 	let hasPhoto = false;
		// 	for (const key in states.item_imgs) {
		// 		if (key.startsWith("photo") && states.item_imgs[key] && states.item_imgs[key]!=="") {
		// 			hasPhoto = true;
		// 			break;
		// 		}
		// 	}
		// 	if (!hasPhoto) {
		// 		validateErrors.push('photo_ids');
		// 	}
		// }
		if( states.override.targets?.includes("price") ){
			var value = states.override.price ? states.override.price as number : 0;
			let maxPrice = ItemPriceMax;
			if( props.owner.high_flag==="1" ){
				maxPrice = ItemPriceMaxHigh;
			}
			if( value < ItemPriceMin || value > maxPrice ){
				validateErrors.push('price');
			}
		}

		if( states.override.targets?.includes("item_guide") ){
			var isEmpty = true;
			for( let i=0; i<states.override.guides.length; i++ ){
				const guide = states.override.guides[i];
				if( guide && guide.label.trim()!=='' ){
					isEmpty = false;
				}
			}
			if( isEmpty ){
				validateErrors.push('guides');
			}
		}

		if( isKakuu && isUnique && validateErrors.length===0 ){
			setStates(prev=>{
				return {
					...prev,
					yesno:"この内容で登録します。\nよろしいですか？",
					deleteIndex:-1,
				}
			});
			return;
		}

		const errors = [] as string[];
		if( validateErrors.length>0 ){
			for( let i=0; i<validateErrors.length; i++ ){
				let mes = '';
				if(validateErrors[i]==='item_name'){
					mes = '商品名';
				} else if(validateErrors[i]==='img_id'){
					mes = 'メイン画像';
				} else if(validateErrors[i]==='item_guide'){
					mes = '商品の紹介文';
				} else if(validateErrors[i]==='promo_text'){
					mes = 'ショートコピー';
				} else if(validateErrors[i]==='thankyou'){
					mes = 'サンキューメッセージ';
				} else if(validateErrors[i]==='unit'){
					mes = '単位';
				} else if(validateErrors[i]==='price'){
					mes = '価格';
				} else if(validateErrors[i]==='page_id'){
					mes = 'シリーズ';
				} else if(validateErrors[i]==='photo_ids'){
					mes = 'ギャラリー';
				} else if(validateErrors[i]==='guides'){
					mes = '商品の紹介文';
				}
				if( mes!=='' ){
					errors.push(mes);
				}
			}
		}
		if( !isKakuu ){
			errors.push('商品名に「架空の」を入れてください');
		} else if( !isUnique ){
			errors.push('この商品名はすでに使われています');
		}
		if( errors.length===0 ){
			let tmp1 = '';
			if( states.errors.length>0 ){
				tmp1 = states.errors.join("/");
			}
			let tmp2 = '';
			if( states.errors.length>0 ){
				tmp2 = states.errors.join("/");
			}
			errors.push('原因不明（システム側に異常の可能性あり）\n'+tmp1+':'+tmp2+'');
		}

		setStates({...states,problems:errors,isProcessing:false});
		return;

	}
	const yes = ()=>{
		if( states.deleteIndex>=0 ){
			deleteGuide();
			return;
		}
		let item_id = 0;
		if( states.override.item_id && states.override.item_id>0 ){
			item_id = states.override.item_id;
		}

		setStates({...states,yesno:"",isLoading:true});
		Ajax.send("override/do",{
			item_id:item_id,
			manager_id:props.managerId,
			override:states.override,
			new_imgs:states.item_imgs,
			//targets:states.targets
		},(res:any)=>{
			if( res.ok ){
				setStates({...defStates});
				props.close(true);
			} else {
				setStates({...states,yesno:"",isLoading:false,isProcessing:false});
				setToast("登録できませんでした");
			}
		},(err:any)=>{
			setStates({...states,yesno:"",isLoading:false,isProcessing:false});
			setToast("登録できませんでした");
		});
	}
	const no = ()=>{
		setStates({...states,deleteIndex:-1,yesno:"",problems:[],isProcessing:false});
	}
	const closeToast = ()=>{
		setToast("");
	}
	const SelectField = (props:{name:keyof Override,value:string,list:Dataset[],width?:number,empty?:boolean})=>{
		if( props.list.length===0 ){
			return (null);
		}
		let w = 2000;
		if( props.width ){
			w = props.width;
		}

		//console.log("value("+props.value+")");

		let value = props.list[0].id;
		if( props.empty ){
			value = '';
		}
		if( props.value && props.value!=='undefined' ){
			let exist = false;
			for( let i=0; i<props.list.length; i++ ){
				if( props.list[i].id===props.value ){
					exist = true;
				}
			}
			if( exist ){
				value = props.value;
			}
		}


		return (
			<Select
				id={"select"+props.name}
				value={value}
				onChange={onChangeSelect(props.name)}
				variant="standard"
				style={{width:'100%',maxWidth:`${w}px`,backgroundColor:'#EEEEEE',boxSizing:'border-box',padding:'0.75em 0.5em'}}
			>
				{props.empty &&
				<MenuItem value='' key='empty'>　</MenuItem>
				}
				{props.list.map((data:Dataset,index:number)=>{
					const key = props.name+index;
					return <MenuItem value={data.id} key={key}>{data.label}</MenuItem>
				})}
			</Select>
		);
	}
	const copyItem = async (name:keyof Override)=>{
		setStates({...states,override:{...states.override,[name]:states.item[name]}});
		setToast("元の商品情報をコピーしました");
	}
	const SectionTitle = (title:string, copyKey:keyof Override | "") => {
		return (
			<Typography variant="h6" style={{display:'flex', alignItems:'center'}}>
				{title}
				{copyKey!=="" &&
				<IconButton
					style={{border:'1px solid teal',borderRadius:'100%',padding:'0.2rem',marginLeft:'0.5rem'}}
					onClick={()=>copyItem(copyKey)}
				><ContentCopyIcon style={{fontSize:'0.8rem',color:'teal'}}/></IconButton>
				}
			</Typography>
		);
	};

	useEffect( ()=>{
		if(!props.isOpen){
			return;
		}
		Ajax.send("item/pages",{format:"ID:{id}　{name}"},(res:any)=>{
			let pages;
			if( res.ok ){
				pages = res.pages;
			} else {
				pages = [];
			}
			load(pages);
		});
	},[props.isOpen]);

	if( states.notFound ){
		return (
			<Redirect to="/"/>
		);
	}

	let helperPrice = ItemPriceMin + "円以上";
	let maxPrice = ItemPriceMax;
	if( props.owner.high_flag==="1" ){
		maxPrice = ItemPriceMaxHigh;
	}
	helperPrice = ItemPriceMin+"円以上"+Tools.comma(maxPrice)+"円以下";

	if( !props.isOpen ){
		return null;
	}

	if( states.isLoading ){
		return (
			<Loading isLoading={true}/>
		);
	}

	let item_id = "未定";
	if(states.override.item_id>0){
		item_id = String(states.override.item_id);
	}

	let tax_inc = "1";
	if( states.override.tax_inc ){
		tax_inc = states.override.tax_inc;
	}

	window.scrollTo(0, 0);

	const targetList = [
		{ id: "item_name", label: "商品名" },
		{ id: "img_id", label: "メイン画像" },
		{ id: "item_guide", label: "商品の紹介文" },
		{ id: "promo_text", label: "ショートコピー" },
		{ id: "thankyou", label: "サンキューメッセージ"},
		{ id: "unit", label: "単位" },
		{ id: "price", label: "価格" },
		{ id: "page_id", label: "シリーズ" },
		{ id: "photo_ids", label: "ギャラリー" },
	];

	return (
		<Dialog
			fullScreen
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
		>
			<DialogContent style={{padding:"0",margin:"0",backgroundColor:'#F5F5F5'}}>

				<AppBar position="fixed" style={{backgroundColor:`#FFFFFF`}}>
					<Toolbar variant="dense" style={{backgroundColor:`#FFFFFF`}}>
						<div style={{color:'#333333',flex:'1'}}><ShoppingCartIcon style={{verticalAlign:'middle',marginRight:'0.25em'}}/><span style={{verticalAlign:'middle'}}>オーバーライド編集</span></div>
						<Button variant="text" color="primary" onClick={close} style={{marginRight:`0.5em`}}>もどる</Button>
						{states.errors.length === 0 ? (
						<Button variant="contained" color="primary" onClick={confirm}>登録</Button>
						):(
						<Button variant="contained" color="info" onClick={confirm} disabled={true}>登録</Button>
						)}
					</Toolbar>
				</AppBar>

				<div style={{maxWidth:'1280px',width:'100%',boxSizing:'border-box',padding:"4em 1em",margin:'0 auto',backgroundColor:'#FFFFFF'}}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={12} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<div className="itemPart0">
								<span>オーバーライド</span>
							</div>
							<Typography variant="h6">
								対象商品
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} md={8}>
							<span className={classes.itemId}>ID:{states.item.item_id}</span>　
							{states.item.item_name}
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

						<Grid item xs={12} sm={12} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<div className="itemPart0">
								<span>オーバーライド</span>
							</div>
							<Typography variant="h6">
								対象イベント
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} md={8}>
							<div>{states.event?.name}（{states.event?.start} - {states.event?.end}）</div>
							{states.event?.period==="100s" &&
							<div style={{marginTop:'0.5em'}}>
								<span style={{backgroundColor:'orange',color:'white',padding:'0 0.25em',borderRadius:'0.25em',marginRight:'0.5rem',fontSize:'0.875rem'}}>ルール</span>
								<span style={{fontSize:'0.92rem',marginRight:'0.5rem'}}>商品名に「架空の」を含む</span><br/>
								<span style={{fontSize:'0.87rem'}}>※元の商品名 または オーバーライドした商品名に含まれていればOK</span>
							</div>}
							{states.override.status==="1" ? (
							<div style={{marginTop:'2em',color:'orange'}}>
								このイベントの期間中だけ、以下の設定内容が有効になります。<br/>
							</div>
							):(
							<div style={{marginTop:'2em',color:'red'}}>
								ステータスを「する」に変更すると、以下の設定内容が有効になります。<br/>
							</div>
							)}

						</Grid>


						<Grid item xs={12}>
							<FormGroup row style={{border:'3px double silver',borderRadius:'0.5em',padding:'1em',position:'relative',marginTop:'2em',marginBottom:'0em',gap:'0 1em'}}>
                                {targetList.map((target) => (
                                    <FormControlLabel
                                        key={target.id}
										sx={{
											'& .MuiFormControlLabel-label': {
												fontSize: '0.875rem',
											},
										}}
                                        control={
                                            <Checkbox
                                                checked={(states.override.targets ?? []).includes(target.id)}
												size="small"
                                                onChange={(_, checked) => {
													if( target.id==="item_name" ){
														return;
													}
                                                    const currentTargets = states.override.targets ?? [];
                                                    const targets = checked
                                                        ? Array.from(new Set([...currentTargets, target.id]))
                                                        : currentTargets.filter((t) => t !== target.id);
													const override = {...states.override, targets};
													if( target.id==="price" ){
														override.tax_inc = "1";
													}
													// if( target.id==="page_id" ){
													// 	if( states.pages[0] ){
													// 		override.page_id = Number(states.pages[0]?.id);
													// 	}
													// }
													if( target.id==="unit" ){
														override.unit = Inc.units[0].id;
													}
                                                    setStates({...states, override: override});
                                                }}
                                            />
                                        }
                                        label={target.label}
                                    />
                                ))}
								<div style={{display:'flex',alignItems:'center',position:'absolute',top:'-1.0em',left:'0.5em',backgroundColor:'#FFFFFF',paddingRight:'0.5em'}}>
									<ExpandMoreIcon style={{fontSize:'200%',color:'grey',marginBottom:'0.1em'}}/>
									<span style={{color:'grey'}}>項目（商品名は必須）</span>
								</div>
							</FormGroup>
							<div style={{marginTop:'0.5rem',color:'#666666',fontSize:'0.875rem'}}>
								各項目の
								<IconButton
									style={{border:'1px solid teal',borderRadius:'100%',padding:'0.2rem',marginLeft:'0.5rem',marginRight:'0.5rem',cursor:'default'}}
								><ContentCopyIcon style={{fontSize:'0.8rem',color:'teal'}}/></IconButton>
								をクリックすると元の商品の内容がコピーされます
							</div>
						</Grid>

						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

						{states.override.targets && states.override.targets.includes("item_name") &&
						<>
						<Grid item xs={12} sm={12} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<div className="itemPart0">
								<span>基本情報 02</span>
							</div>
							{SectionTitle("商品名", "item_name")}
							<div className="formExplanation">
								商品名に「架空の」を入れてください<br/>
								元の商品名と同じにすることもできます<br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={12} md={8}>
							<InputString label="商品名" required={false} value={states.override.item_name} onChange={onChangeString("item_name")} helper={ItemNameLengthMin+'文字以上'+ItemNameLengthMax+'文字以内'} opt={{minLength:ItemNameLengthMin,maxLength:ItemNameLengthMax}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						</>}
						{states.override.targets && states.override.targets.includes("img_id") &&
						<>
						<Grid item xs={12} sm={12} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<div className="itemPart0">
								<span>基本情報 01</span>
							</div>
							{SectionTitle("メイン画像", "")}
							<div className="formExplanation">
								販売ページの最初に表示される大きな画像です。<br/>
								幅1280pxの画像を用意するとキレイに表示されます。<br/>
								<div className="formHint">
									※PNG/JPEG/GIFでJPEGに変換して保存されます<br/>
									※1280pxより大きい場合は自動的に縮小されます<br/>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} sm={12} md={8}>
							<div style={{textAlign:"center"}}>
								<DropImage noHelper={true} owner_id={props.owner.owner_id} img_id={states.override.img_id} id="img" change={changeImage}/>
							</div>
							<div className="formHelper">
								画像を登録するには「ここに追加」をクリックもしくは画像をドラッグして下さい
							</div>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						</>}

						{states.override.targets && states.override.targets.includes("item_guide") &&
						<>
						<Grid item xs={12} sm={12} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<div className="itemPart0">
								<span>基本情報 03</span>
							</div>
							{SectionTitle("商品の紹介文", "guides")}
							<div className="formExplanation">
								商品の内容やチャームポイントをなるべくわかりやすく書いてください<br/>
								段落ごとに見出しをつけることもできます（段落は最大５個）<br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={12} md={8}>
							{states.override.guides.map((guide:DataErrorset2,index:number)=>{
								const key = "guide"+index;
								return (
							<div style={{marginBottom:'1em',position:'relative'}} key={key}>
								<div style={{marginBottom:'0.5em'}}><InputString label="見出し" required={false} value={guide.id} onChange={onChangeGuide(index,0)} helper={ItemGuideNameLengthMax+'文字以内・省略可'} opt={{maxLength:ItemGuideNameLengthMax}}/></div>
								<div><InputString label="本文" required={false} value={guide.label} onChange={onChangeGuide(index,1)} helper={Tools.comma(ItemGuideLengthMax)+'文字以内'} opt={{rows:10,maxLength:ItemGuideLengthMax}}/></div>
								{index>0 &&
								<div style={{textAlign:'right',position:'absolute',bottom:'-0.5em',right:'0',margin:'0',padding:'0'}}>
									<Button variant="text" color="secondary" size="small" onClick={confirmDelete} data-num={index}><DeleteIcon/> 段落削除</Button>
								</div>
								}
							</div>
								)
							})}
							<div style={{textAlign:'left'}}>
								<Button variant="outlined" color="primary" onClick={addGuide} disabled={states.override.guides.length===5}><AddIcon/> 段落追加</Button>
							</div>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						</>}
						{states.override.targets && states.override.targets.includes("promo_text") &&
						<>
						<Grid item xs={12} sm={12} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<div className="itemPart0">
								<span>基本情報 04</span>
							</div>
							{SectionTitle("ショートコピー", "promo_text")}
							<div className="formExplanation">
								12文字までの短い宣伝メッセージです<br/>
								商品一覧などで商品名と一緒に表示されます<br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={12} md={8}>
							<InputString label="ショートコピー" required={false} value={states.override.promo_text} onChange={onChangeString("promo_text")} helper={ItemPromoTextLengthMax+'文字以内'} opt={{maxLength:ItemPromoTextLengthMax}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						</>}
						{states.override.targets && states.override.targets.includes("thankyou") &&
						<>
						<Grid item xs={12} sm={12} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<div className="itemPart0">
								<span>基本情報 05</span>
							</div>
							{SectionTitle("サンキューメッセージ", "thankyou")}
							<div className="formExplanation">
								お客様が商品をカートに入れた時に表示されるメッセージです<br/>
								省略した場合はメッセージは表示されません<br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={12} md={8}>
							<InputString label="サンキューメッセージ" required={false} value={states.override.thankyou} onChange={onChangeString("thankyou")} helper={ItemThankyouLengthMax+'文字以内'} opt={{maxLength:ItemThankyouLengthMax}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						</>}
						{states.override.targets && states.override.targets.includes("unit") &&
						<>
						<Grid item xs={12} sm={12} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<div className="itemPart0">
								<span>基本情報 06</span>
							</div>
							{SectionTitle("単位", "unit")}
							<div className="formExplanation">
								商品の単位（数え方）に適切な言葉を選んでください
							</div>
						</Grid>
						<Grid item xs={12} sm={12} md={8}>
							<SelectField value={states.override.unit} name="unit" list={Inc.units} width={160}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						</>}
						{states.override.targets && states.override.targets.includes("price") &&
						<>
						<Grid item xs={12} sm={12} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<div className="itemPart0">
								<span>基本情報 07</span>
							</div>
							{SectionTitle("価格", "price")}
							<div className="formExplanation">
								「税抜」で登録しておくと、今後消費税率が変わった時に自動的に新しい消費税率で計算した価格が表示されます
							</div>
						</Grid>
						<Grid item xs={4} sm={4} md={2}>
							<SelectField name="tax_inc" value={tax_inc} list={Inc.taxs}/>
						</Grid>
						<Grid item xs={8} sm={8} md={6}>
							<InputNumber label="価格" required={true} value={states.override.price} onChange={onChangeNumber("price")} helper={helperPrice} opt={{minValue:ItemPriceMin,maxValue:maxPrice,endAdornment:"円"}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						</>}
						{states.override.targets && states.override.targets.includes("page_id") &&
						<>
						<Grid item xs={12} sm={12} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<div className="itemPart1">
								<span>詳細情報 03</span>
							</div>
							{SectionTitle("シリーズ", "page_id")}
							<div className="formExplanation">
								同じシリーズの商品は各商品ページにズラリと表示され、関連商品としてお客様に選んでいただきやすくなります
							</div>
						</Grid>
						<Grid item xs={12} sm={12} md={8}>
							{states.pages.length>0 ? (
							<SelectField name="page_id" value={String(states.override.page_id)} list={states.pages} empty={true}/>
							):(
							<div className="formHint">
								※シリーズを設定したい場合は、「商品と納品」→「シリーズ登録」で作成してください<br/>
							</div>
							)}
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						</>}
						{states.override.targets && states.override.targets.includes("photo_ids") &&
						<>
						<Grid item xs={12} sm={12} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<div className="itemPart2">
								<span>ファイル・画像 01</span>
							</div>
							{SectionTitle("ギャラリー", "photo_ids")}
							<div className="formExplanation">
								商品ページのフォトギャラリーに表示される画像です<br/>
								<div className="formHint">
									※PNG/JPEG/GIFで、8枚まで登録できます<br/>
									※JPEGに変換して保存されます<br/>
									※幅1280px高さ1800pxより大きい場合は自動的に縮小されます<br/>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} sm={12} md={8}>
							<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
								{states.override.photo_ids.map((img_id:number,index:number)=>{
									const key = "photo"+String(index+1);
									const name = "ギャラリー" + String(index+1);
									return (
										<div key={key} style={{ flex: '0 0 auto', width: '100px', height: '75px' }}>
											<DropImageLight noHelper={true} owner_id={props.owner.owner_id} img_id={img_id} data={states.item_imgs[key]} name={name} id={key} change={changeImage}/>
										</div>
									);
								})}
							</div>
							<div className="formHelper" style={{marginTop:'1em'}}>
								画像を登録するには「ここに追加」をクリックもしくは画像をドラッグして下さい
							</div>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						</>}

						<Grid item xs={12} sm={12} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<div className="itemPart0">
								<span>オーバーライド</span>
							</div>
							<Typography variant="h6">
								ステータス
							</Typography>
							<div className="formExplanation">
								以上の内容でオーバーライドしてよろしければ「する」を選んで下さい
								<div className="formHint">
									※しない（保留・下書き）を選ぶと、対象イベントの期間中でも通常の商品情報が表示されます<br/>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} sm={12} md={8}>
							<ColInput name="" filled={true} value={states.override.status} change={changeRadio} id="status" type="radio" list={Inc.overrideStatus}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

					</Grid>
				</div>
			</DialogContent>
			<Yesno mes={states.yesno} yes={yes} no={no} isOpen={states.yesno!==""}/>
			<Problems names={states.problems} yes={yes} no={no} force={false} isOpen={states.problems.length>0}/>
			<Toast mes={toast} close={closeToast}/>
		</Dialog>
	);
}

export default OverrideInput;
